import { http } from './index'
import COS from 'cos-js-sdk-v5'
import { ElMessage } from 'element-plus'

const getAuthorization = (
  _: COS.GetAuthorizationOptions,
  callback: (params: COS.GetAuthorizationCallbackParams) => void
) => {
  http.get('/api/auth/tencent/uploadToken').then((res) => {
    const data = res as any
    callback({
      TmpSecretId: data.credentials.tmpSecretId,
      TmpSecretKey: data.credentials.tmpSecretKey,
      SecurityToken: data.credentials.sessionToken,
      StartTime: data.startTime,
      ExpiredTime: data.expiredTime
    })
  })
}

const cos = new COS({
  getAuthorization,
  Domain: 'community-1313503552.cos.accelerate.myqcloud.com',
  Protocol: 'https:'
})

const upload = async (file: File, key: string): Promise<string> =>
  new Promise((resolve, reject) => {
    cos.uploadFile(
      {
        Bucket: 'community-1313503552' /* 填入您自己的存储桶，必须字段 */,
        Region: 'ap-nanjing' /* 存储桶所在地域，例如ap-beijing，必须字段 */,
        Key:
          key ??
          file.lastModified +
            file.name /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */,
        Body: file /* 必须，上传文件对象，可以是input[type="file"]标签选择本地文件后得到的file对象 */,
        SliceSize: 1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，非必须 */
      },
      (err, data) => {
        if (err) {
          ElMessage({ message: '上传错误：' + err.message, type: 'error' })
          reject(err.message)
        } else {
          resolve(
            ('https://' + data.Location).replace(
              'community-1313503552.cos.accelerate.myqcloud.com',
              'material.ytaxx.com'
            )
          )
        }
      }
    )
  })

export default upload
